<template>
    <div class="row">
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
        </loading>
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>COGS Sale</h5>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                    <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                      <i class="fa fa-filter" aria-hidden="true"></i>
                        Filter
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu p-2" >
                      <span>Company:</span>
                      <div class="dropdown-divider"></div>
                      <li v-for="ct in companyList" :key="ct.id">
                        <a href="#" class="small" tabIndex="-1">
                          <input type="checkbox" :value="ct.company_no" v-model="filterCompany"/>&nbsp; {{ ct.name }}
                        </a>
                      </li>
                    </ul>
                    <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                    rows:
                    <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                      <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                    </select>
                    <span class="mr-1">
                      Total rows: <b>{{ filterData.length }}</b>
                    </span>
                    <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <h5>Total: {{ totalSales | currency }}</h5>
                <table class="table table-item mb-0 table-sm table-striped">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                            <th>#</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="8" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer">
                        <td>
                          <label class="form-checkbox">
                            <input type="checkbox" :value="u.id" v-model="selected">
                            <i class="form-icon"></i>
                          </label>
                        </td>
                        <td>
                            <span class="badge badge-success" v-if="u.status === 'completed'">{{ u.status }}</span>
                            <span class="badge badge-warning" v-else-if="u.status === 'outstanding'">{{ u.status }}</span>
                            <span class="badge badge-primary" v-else-if="u.status === 'approved'">{{ u.status }}</span>
                            <span class="badge badge-warning" v-else-if="u.status === 'order'">{{ u.status }}</span>
                            <span class="badge badge-danger" v-else>{{ u.status }}</span>
                        </td>
                        <td>{{ u.sale_no }}</td>
                        <td>{{ u.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>[{{ u.product_no }}] {{ u.description }}</td>
                        <td>{{ u.company_no }}</td>
                        <td>{{ u.warehouse_no }}</td>
                        <td>{{ u.qty }}</td>
                        <td>{{ u.uom_id }}</td>
                        <td class="text-right">{{ u.price | currency }}</td>
                        <td class="text-right">{{ u.cost | currency }}</td>
                        <td>
                            <button class="btn btn-sm btn-hard-primary" @click="setCOGS(u.product_no, u.sale_date, u.company_no)">Sync</button>
                            <button class="btn btn-sm btn-hard-primary" data-toggle="modal" data-target="#modalProductCost" data-backdrop="static" data-keyboard="false" @click="getCOGS(u.product_no, u.company_no)">COGS</button>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
      <ProductCostListModal />
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { productUrl, salesUrl, getHeader } from '../config'
import ProductCostListModal from '@/components/product/ProductCostListModal.vue'

export default {
  name: 'SaleCOGS',
  components: {
    Loading,
    DatePicker,
    ProductCostListModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterCompany: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Sale No.',
        prop: 'sale_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'sale_date',
        align: 'text-left'
      }, {
        name: 'Product',
        prop: 'product_no',
        align: 'text-left'
      }, {
        name: 'Company',
        prop: 'company_no',
        align: 'text-left'
      }, {
        name: 'Warehouse',
        prop: 'warehouse_no',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'qty',
        align: 'text-left'
      }, {
        name: 'Uom',
        prop: 'uom_id',
        align: 'text-left'
      }, {
        name: 'Price',
        prop: 'price',
        align: 'text-right'
      }, {
        name: 'COGS',
        prop: 'cost',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCompanyList')
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    totalSales () {
      var array = this.filterCompany
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var sales = this.dataRaw.filter(d => d.company_no === array[i])
        for (let i = 0; i < sales.length; i++) {
          sum += parseFloat(sales[i].price)
        }
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    getCOGS (product, company) {
      var payload = {
        begin: null,
        end: null,
        product_no: product,
        company_no: company
      }
      this.$store.dispatch('getProductCogsByNo', payload)
    },
    async setCOGS (product, date, company) {
      var data = {
        date: date,
        product_no: product,
        type: 'all',
        company_no: company
      }
      await axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: null
      }
      var url = salesUrl + '/detail/cogs'
      axios.post(url, obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
